/**
 * Game-score text. Handicapped sides can finish a game below zero, and "11–-4" is unreadable,
 * so a negative score is shown with a true minus sign in brackets: "11–(−4)". Non-negative
 * scores are untouched ("7–11"). Same convention as the API's result/export text.
 */
export const scorePoints = (v) => {
  if (v == null || v === '') return '';
  const n = Number(v);
  return Number.isFinite(n) && n < 0 ? `(−${Math.abs(n)})` : String(v);
};

export const gameScoreText = (home, away, sep = '–') => `${scorePoints(home)}${sep}${scorePoints(away)}`;
